import React from "react";
import { Route, Switch } from "react-router";
import { connect } from "react-redux";

import { Button, Nav, NavItem } from "bootstrap-micro";
import { RelayConfiguration } from "./RelayConfiguration.jsx";

import update from "immutability-helper";
import { RelayActionEditor } from "./RelayActionEditor.jsx";
import { sitesFetch, selectAllSites } from "../store/sitesSlice.js";
import { relayDelete, relaysFetch, relayUpdate, selectRelayById } from "../store/relaysSlice.js";

const ON_ACTION = { relay_1: 0, relay_2: 0, io_1: false, io_2: false, io_3: false, io_4: false }

export class RelayEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            config: null,
            isDirty: false
        }

    }
    componentDidMount() {
        this.props.loadRelay();
        this.props.loadSites();
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (!this.state.isDirty) {
            this.setState({ config: newProps.relay })
        }
    }
    validState() {
        return (true);
    }
    inpBind(key) {
        return {
            value: this.state[key],
            onChange: ev => this.setState({ [key]: ev.target.value })
        }
    }
    renderError() {
        if (this.state.error) {
            return <div className="col-md-6 col-md-offset-3">
                <div className="alert alert-danger" role="alert" id="error-message">{this.state.error}</div>
            </div>;
        }
    }
    render() {
        let remainingSites = this.props.availableSites.filter(p => (!this.state.config || !this.state.config.actions.map(a => a.hwaddr).includes(p.hwaddr)));
        return <div className="container">
            <div role="tabpanel" className="nav-center">
                <Nav bsStyle="tabs" activeHref={window.location.hash}>
                    <NavItem href={`#/relay/${this.props.match.params.id}`}>Actions</NavItem>
                    <NavItem href={`#/relay/${this.props.match.params.id}/edit`}>Edit Settings</NavItem>

                </Nav>
            </div>
            <div className="row container" style={{ paddingTop: "20px" }}>
                <div className="row">
                    {this.renderError()}

                </div>
                <div className="row">
                    <Switch>
                        <Route exact path={`${this.props.match.url}`} render={() => {
                            if (!this.state.config) {
                                return null;
                            }
                            return <React.Fragment>
                                <div className="col-md-10 col-md-offset-1" style={{ marginBottom: "20px" }}>
                                    <form className="form-inline" onSubmit={ev => {
                                        ev.preventDefault();
                                        ev.stopPropagation();
                                        let fd = new FormData(ev.target);
                                        this.setState(update(this.state, { config: { actions: { $push: [{ hwaddr: fd.get("hwaddr"), on_fire: ON_ACTION, on_fault: ON_ACTION }] } } }))
                                    }}>
                                        <div className="form-group">
                                            <label htmlFor="hwaddr">Setup actions for site:&nbsp;</label>
                                            <select className="form-control " name="hwaddr" required>
                                                {remainingSites.length == 0 ?
                                                    <option disabled>No other sites found</option> :
                                                    remainingSites.map(entry => <option key={entry.hwaddr} value={entry.hwaddr}>{entry.name} ({entry.hwaddr.replace(/([0-9a-f]{2})(?!$)/g, "$1:")})</option>)
                                                }
                                            </select>
                                        </div>
                                        <Button style={{ marginLeft: "5px" }} bsStyle="info" type="submit" disabled={remainingSites.length == 0}>Add Action</Button>
                                    </form>
                                </div>
                                {this.state.config.actions.map((action, key) => <RelayActionEditor onNewRemove={() => this.setState(update(this.state, { config: { actions: { $splice: [[key, 1]] } } }))} key={key} relayId={this.state.config.id} action={action} />)}
                            </React.Fragment>
                        }} />
                        <Route exact path={`${this.props.match.path}/edit`} render={() => {
                            if (this.state.config) {
                                return <React.Fragment>
                                    <RelayConfiguration
                                        onRemove={() => {
                                            /* eslint-disable-next-line no-alert */
                                            if (confirm("Delete this relay?")) {
                                                this.props.deleteRelay(this.state.config.id).then(() => {
                                                    location.href = "/#/";
                                                });
                                            }
                                        }}
                                        value={this.state.config}
                                        onChange={config => this.setState({ isDirty: true, config })}
                                        disabled={!this.state.isDirty}
                                        onSave={() => this.props.updateRelay(
                                            this.state.config.id,
                                            this.state.config.host,
                                            this.state.config.name,
                                            this.state.config.port,
                                            this.state.config.password
                                        ).then(() => this.setState({ isDirty: false }))} />
                                </React.Fragment>
                            } else {
                                return null;
                            }
                        }} />
                    </Switch>



                </div>
            </div>
        </div>
    }
}

export default connect((state, ownProps) => {
    let relay = selectRelayById(state, ownProps.match.params.id);
    return {
        availableSites: selectAllSites(state).filter(r => (relay == null || !relay.actions.map(a => a.hwaddr).includes(r.hwaddr)) && r.status == "AUTHED"),
        relay,
    }

}, {
    loadRelay: relaysFetch,
    loadSites: sitesFetch,
    updateRelay: relayUpdate,
    deleteRelay: relayDelete,

})(RelayEditor)